import React from "react";
import { ServicePage } from "@/components/ServicePage";
import { BackupExplainers } from "@/components/explainers/BackupExplainers";

export const ManagedBackup = () => (
  <ServicePage
    slotAfterFeatures={<BackupExplainers />}
    testIdSlug="managed-backup"
    seo={{
      title: "Managed Backup & Recovery · Datensicherung",
      description: "Managed Backup & Recovery mit Active Protection, Air-Gap und garantiertem Restore. Datensicherung und Wiederherstellung aus der IT-Servicepoint Cloud.",
      keywords: "Managed Backup, Backup as a Service, Datensicherung, Unified Backup, Disaster Recovery, Acronis, Air-Gap Backup, Ransomware Schutz",
      serviceName: "Managed Backup & Recovery",
      breadcrumb: [
        { name: "Start", path: "/" },
        { name: "Managed Backup", path: "/managed-backup" },
      ],
    }}
    eyebrow="Managed Backup & Recovery"
    title="Datensicherheit. Neu definiert."
    subtitle="Wir kümmern uns um die Sicherung und Wiederherstellung Ihrer Kronjuwelen – automatisch, verschlüsselt und mit garantiertem Restore."
    heroImage="/wp-images/managed-backup.jpg"
    features_intro="Vier Säulen, auf die Sie sich verlassen können – auch wenn es eng wird."
    features={[
      { title: "Automatisierte Backups", desc: "Regelmäßige, automatische Sicherung Ihrer Daten – ohne manuellen Aufwand." },
      { title: "Schnelle Wiederherstellung", desc: "Datei- oder Laufwerks-Restore in Minuten statt Tagen." },
      { title: "Cloud-Speicherintegration", desc: "Air-Gap Storage in der IT-Servicepoint Cloud – ausgelagert und versichert." },
      { title: "Verschlüsselter Datenschutz", desc: "End-to-End Verschlüsselung mit modernsten Verfahren." },
      { title: "Active Protection", desc: "Backups werden aktiv vor Ransomware-Verschlüsselung geschützt." },
      { title: "Skalierbar", desc: "Kapazität wächst mit Ihrem Unternehmen – flexibel und transparent." },
    ]}
    bullets={[
      "Automatisierung in festen Intervallen",
      "Sichere Speicherung an getrennten Orten",
      "Wiederherstellung mit wenigen Klicks",
      "Versicherungs-konforme Aufbewahrung",
      "3-2-1 Backup-Strategie inklusive",
      "Zertifizierte Datenrettung bei Bedarf",
    ]}
    testimonials={[
      { quote: "Dank Managed Backup konnten wir nach einem Systemausfall in unter einer Stunde wieder produktiv arbeiten.", name: "Anna Müller", role: "IT-Leiterin" },
      { quote: "Die schnelle Reaktion und exzellenten Ergebnisse haben uns überzeugt. Unser Unternehmen ist bestens abgesichert.", name: "Maximilian Schulz", role: "Systemadministrator" },
      { quote: "Die umfassende Betreuung und hohe Datensicherheit geben uns ein beruhigendes Gefühl – absolut empfehlenswert.", name: "Lisa Bergmann", role: "Geschäftsführerin" },
    ]}
  />
);
